import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import { Container } from 'components/atoms/container'
import { useIsMobile } from 'hooks/useIsMobile'
import { Product } from 'interfaces/types/Ecommerce'

import useStyles from './index.styles'
import { ProductsWidget } from '../productsWidget'

type Props = {
  title: string
  products: Product[]
  bgColor: string
  applyH1?: boolean
} & BoxProps

const CarePathProductWidgets = ({
  title,
  products = [],
  styles,
  classNames,
  className,
  bgColor,
  applyH1,
}: Props) => {
  const isMobile = useIsMobile()
  const productNumber = products.length
  const { classes, cx } = useStyles(
    { bgColor, productNumber },
    { name: 'CarePathProductWidgets', styles, classNames },
  )
  return products.length > 0 ? (
    <Box className={cx(classes.root, className)}>
      <Container>
        <Box className={classes.inner}>
          {title && (
            <Text
              size="h2"
              as={applyH1 ? 'h1' : 'h3'}
              className={classes.heading}
            >
              {title}
            </Text>
          )}
          <ProductsWidget
            products={products}
            numberItemToSlideDesktop={6}
            numberItemToSlideMobile={2}
            cartBtnColor={bgColor}
            layout={
              isMobile
                ? new Array(productNumber).fill('wide-horizon')
                : ['wide-horizon', 'wide-horizon', 'horizon', 'vertical']
            }
            classNames={{
              root: classes.widgets,
              progressBar: classes.progressBar,
              progressRoot: classes.progressRoot,
              cardRoot: classes.cardRoot,
            }}
          />
        </Box>
      </Container>
    </Box>
  ) : null
}

export { CarePathProductWidgets }
